<template>
    <div class="sideprojects">
        <transition name="switch-top">
            <div class="sideprojects__teaser" v-if="teaserVisible">
                <img loading=lazy :src="selectedProject.image.url"/>
                <div class="text">
                    <span>↗</span>
                </div>
            </div>
        </transition>

        <div class="container">
            <h4 class="sideprojects__headline">Other Projects</h4>
            <div 
                class="sideprojects__wrapper" 
                @mousemove="handleSideProjectsHover($event)"
                @mouseenter="handleSideProjectsVisibility(true)"
                @mouseleave="handleSideProjectsVisibility(false)">
                <a 
                    @mouseenter="setCurrentProject(sideproject)"
                    class="sideprojects__link" 
                    target="_blank" 
                    v-for="sideproject in sideprojects" 
                    :key="sideproject.name"
                    :id="sideproject.name"
                    :href="sideproject.link.url"> 
                    {{ sideproject.name }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        mapState
    } from 'vuex'

    export default {
        data() {
            return {
                sideprojects: null,
                selectedProject: "undefined",
                teaserVisible: false
            }
        },
        created() {
            this.getSideProjects()
        },
        methods: {
            getSideProjects() {
                this.$prismic.client.getSingle('sideprojects')
                    .then((document) => {
                        this.sideprojects = document.data.projects
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },

            easing(t) {
                return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1
            },

            handleSideProjectsHover (event) {
                const teaser = this.$el.querySelector('.sideprojects__teaser')
                const x = event.pageX
                const y = event.pageY

                var rect = event.target.getBoundingClientRect();
                var relX = event.clientX - rect.left; //x position within the element.
                var relY = event.clientY - rect.top;  //y position within the element.

                const width = event.target.offsetWidth;
                const height = event.target.offsetHeight;
                
                teaser.style.transform = "translate(" + ( (x) - 64 )  + "px, " + ( this.easing(-(height - relY) * 0.05) - (height - 24)) + "px)";
            },

            handleSideProjectsVisibility(isActive) {
                this.teaserVisible = isActive;
            },

            setCurrentProject(project) {
                this.selectedProject = project
            }
        }
    }
</script>

<style lang="scss">
    @import '../../assets/scss/base.scss';

    .sideprojects {
        padding: 4rem 1.5rem;
        background: $white-40;
        position: relative;

        &__headline {
            display: block;
            margin: 0 1rem .5rem 0;
            color: $white-100;
        }

        &__link {
            font-family: 'Franziska Book';
            font-size: 1.25rem;
            color: $white-100;
            text-decoration: none;
            display: inline-block;
            margin: 0 0.5rem 0 0;
            position: relative;

            &:not(:last-child) {
                padding-right: 1rem;
            }

            &:not(:last-child):before {
                position: absolute;
                content: '∙';
                display: block;
                top: 0;
                right: 0;

            }

            &:after {
                content: '';
                position: relative;
                width: 100%;
                display: block;
                bottom: 2px;
                height: 1px;
                background: $white-60;
            }
        }

        &__wrapper {
            display: inline-block;
            width: auto;
        }

        &__teaser {
            position: absolute;
            width: auto;
            height: calc(10rem * 1.25);
            width: calc(15rem * 1.25);
            background: $light-background;
            transition: 100ms $spring;
            bottom: 50%;

            $border-radius: 8px;
            border-radius: $border-radius;
            border: 1px solid $port-background-transparent;
            
            overflow: hidden;

            box-shadow: 0px 32px 32px 42px rgba(255, 255, 255, 0.04);

            .text {
                position: absolute;
                font-family: 'Inter';
                font-size: 1.5rem;
                font-weight: 700;
                bottom: 0;
                right: .25rem;
                background: $white-60;
                padding: 0.25rem 0.45rem 0 0.45rem;
                z-index: 10;
                margin: .25rem 0;
                border-radius: 4px;
                span {
                    color: $dark-60;
                }
            }

            img {
                width: 102%;
                height: 102%;
                object-fit: cover;
            }
        }
    }
</style>